(function () {
  const mobileQuery = window.matchMedia('(max-width: 1023px)');

  function initSplitProducts(section) {
    const media = section.querySelector('.custom-split-products__media');
    const images = section.querySelectorAll('.custom-split-products__image');

    if (!media || images.length < 2) return;

    let intervalId = null;
    let activeIndex = 0;
    let hasZoomed = false;

    const interval = Number(section.dataset.mobileInterval) || 4000;

    function showImage(index) {
      images.forEach((image, imageIndex) => {
        image.classList.toggle('is-active', imageIndex === index);
      });
    }

    function startMobileRotation() {
      stopMobileRotation();

      showImage(activeIndex);

      intervalId = window.setInterval(() => {
        activeIndex = activeIndex === 0 ? 1 : 0;
        showImage(activeIndex);
      }, interval);
    }

    function stopMobileRotation() {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }

      images.forEach((image) => {
        image.classList.remove('is-active');
      });

      images[0].classList.add('is-active');
      activeIndex = 0;
    }

    function handleMode() {
      if (mobileQuery.matches) {
        startMobileRotation();
      } else {
        stopMobileRotation();
        section.classList.remove('is-mobile-zoomed');
        hasZoomed = false;
      }
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            mobileQuery.matches &&
            !hasZoomed
          ) {
            hasZoomed = true;
            section.classList.add('is-mobile-zoomed');
          }
        });
      },
      {
        threshold: 0.35
      }
    );

    observer.observe(media);

    handleMode();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleMode);
    } else {
      mobileQuery.addListener(handleMode);
    }

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(section)) {
        stopMobileRotation();
        observer.disconnect();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.custom-split-products').forEach(initSplitProducts);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.custom-split-products');
    if (section) initSplitProducts(section);
  });
})();